import { Button } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import LeihBar from 'assets/leihBar_Logo.svg';
import { translations } from 'locales/i18n';

export const ToLeihbarButton = () => {
  const { t } = useTranslation();
  return (
    <Link to="/leihbar">
      <Button
        variant="outlined"
        startIcon={
          <img
            src={LeihBar}
            alt=""
            width="25vw"
            height="25vh"
            style={{ justifySelf: 'center', marginRight: '5px' }}
          />
        }
      >
        {t(translations.pages.leihbarMailSettings.toLeihbar())}
      </Button>
    </Link>
  );
};
